import styled from "styled-components"
import theme from "../Theme"

const getColor = ({ error, warn, theme }) =>
  (error && theme.danger) || (warn && theme.warning) || theme.foregroundText

const Select = styled.select`
  display: block;
  width: 100%;
  padding: .5rem .75rem;
  font-size: 1rem;
  line-height: 1.25em;
  color: ${props => getColor(props)};
  background-color: #fff;
  background-image: none;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, .15);
  border-radius: ${props => props.theme.borderRadius || 0};
  height: 2.25rem;
`

Select.defaultProps = {
  theme
}

export default Select



// WEBPACK FOOTER //
// ./src/UI/Form/Select.js